import { createElement, forwardRef } from 'react';
import bundle from './NovaComponents-ObjectManager-gui-icu.properties';
import { createUseTextLocalizer } from '../../locale/createUseTextLocalizer';
import { Button, ButtonVariant } from '../Button';
import { useFormatter } from '../../locale/formatting';
import { ObjectSwitcherLaunchButtonProps } from './types';
import { useDesignTokens } from '../../theme';

const useTextLocalizer = createUseTextLocalizer(bundle);

/**
 * Wrapper around the button that launches the ObjectSwitcher
 */
export const ObjectSwitcherLaunchButton = forwardRef<
  HTMLButtonElement,
  ObjectSwitcherLaunchButtonProps
>(function ObjectSwitcherLaunchButton(props, forwardedRef) {
  const localize = useTextLocalizer();
  const formatter = useFormatter();
  const numberOfObjects = formatter?.formatNumeric(props.numberOfObjects);
  let openedItemsText = localize('objectManager.objectSwitcher.openedItems.button.label');
  if (props.numberOfObjects > 0) openedItemsText = `${openedItemsText} (${numberOfObjects})`;
  const dt = useDesignTokens();
  return (
    <Button
      ref={forwardedRef}
      text={openedItemsText}
      testId={props.testId}
      variant={ButtonVariant.Light}
      focusable={props.focusable}
      disabled={props.disabled ?? props.numberOfObjects === 0}
      onPress={props.onPress}
      tokens={({ disabled }) => ({
        fg: disabled ? dt.stateStandardNova.disabled.fg : dt.c.colorTextPrimary,
      })}
    />
  );
});
